import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";

import { DealCategoryTable } from "./DealCategoryTable";
import { CreateDealForm } from "./CreateDealForm";
import DealTable from "./DealTable";
const tabs = ["Deals", "Category", "Create Deal"];
export const Deals = () => {
  const [activeTab, setActiveTab] = useState("Deals");
 
  return (
    <div className="h-full">
      <div className="flex space-x-4 ">
        {tabs.map((item) => (
          <Button
            onClick={() => {
              setActiveTab(item);
            }}
            variant={activeTab == item ? "contained" : "outlined"}
          >
            {item}
          </Button>
        ))}
      </div>
      <div className="sm:mt-5 sm:py-5">
        {activeTab == "Deals" ? (
          <DealTable />
        ) : activeTab == "Category" ? (
          <DealCategoryTable />
        ) : (
         <div className="sm:mt-5 flex flex-col justify-center items-center h-[60vh] sm:h-[40vh]">
           <CreateDealForm setActiveTab={setActiveTab} />
         </div>
        )}
      </div>
    </div>
  );
};
